import React from 'react'
import { Card, Col, Container, Row, Table } from 'react-bootstrap'

import Layout from 'src/components/Landing/Layout'

const LinksPage: React.FC = () => {
  return (
    <Layout title="Links">
      <div style={{ height: '100vh', backgroundColor: '#F4F4FC' }}>
        <section>
          <Container>
            <Row className="justify-content-center">
              <Col md={8}>
                <Card>
                  <Card.Body>
                    <Table>
                      <thead>
                        <th>Platform</th>
                        <th>Test</th>
                        <th>Live</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Deprecated</td>
                          <td>
                            <a
                              href="https://web.clairbleu.com"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              web.clairbleu.com
                            </a>
                          </td>
                          <td>
                            <a
                              href="https://shelfie-temp.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              shelfie-temp.netlify.app
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Pilot (Web)</td>
                          <td>-</td>
                          <td>
                            <a
                              href="https://weshelfie-old.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              weshelfie-old.netlify.app
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>ClearBlue</td>
                          <td>
                            <a
                              href="https://weshelfie.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              weshelfie.netlify.app
                            </a>
                          </td>
                          <td>
                            <a
                              href="https://clearblue.weshelfie.com"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              clearblue.weshelfie.com
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Mobile (Pilot)</td>
                          <td>-</td>
                          <td>
                            <a
                              href="https://etc.weshelfie.com/apk/clearblue-pilot.apk"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Pilot
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Mobile</td>
                          <td>
                            <a
                              href="https://etc.weshelfie.com/apk/clearblue-test.apk"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Test
                            </a>
                          </td>
                          <td>
                            <a
                              href="https://etc.weshelfie.com/apk/clearblue-live.apk"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Live
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  )
}

export default LinksPage
